module.exports = __webpack_public_path__ + "static/media/3DPPA20.b4c0df38.jpg";